import { render } from "./AppMenuMobile.vue?vue&type=template&id=007afa0b"
import script from "./AppMenuMobile.vue?vue&type=script&lang=js"
export * from "./AppMenuMobile.vue?vue&type=script&lang=js"

import "./AppMenuMobile.vue?vue&type=style&index=0&id=007afa0b&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__